export default `float i,g,e,R=2.,S;
    for(int j=0;j++<9;)
      p=1.-abs(p-1.),
      p*=S=(j%3>1)?1.3:1.2/dot(p,p),
      R*=S;
    return length(cross(p,vec3(.5)))/R-5e-3;
  }`